<label class="section-label heading2">Period Totals </label>

<div
  id="period-totals"
  *ngIf="data$ | async as data"
  [ngClass]="{ admin: isAdmin }"
>
  <div class="item" *ngIf="isAdmin">
    <div class="label1">Active Venues</div>
    <div class="contentText">
      {{ data.venues }}
    </div>
  </div>

  <div class="item">
    <div class="label1">Revenue</div>
    <div class="contentText">
      {{ mask(data.revenue) }}
    </div>
  </div>
  <div class="item">
    <div class="label1">Units Sold</div>
    <div class="contentText">{{ data.units }}</div>
  </div>
  <!-- <div class="item">
    <div class="label1">New Customers</div>
    <div class="contentText">{{ data.nUsers }}</div>
  </div> -->
  <div class="item">
    <div class="label1">Unique Customers</div>
    <p class="contentText">
      {{ data.uUsers }}
    </p>
  </div>
</div>
